import { TimeRange } from "@nova/component-charts"
import { createSelector, createSlice } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"

type PilotsSlice = {
    search: string
    view: "grid" | "table"
    tab: "overview" | "history"
    historyView: "table" | "map"
    activityTimeRange: TimeRange
}

const initialState: PilotsSlice = {
    search: "",
    view: "grid",
    tab: "overview",
    historyView: "table",
    activityTimeRange: "all",
}

export const pilotsSliceName = "pilots" as const

export const {
    actions: { setSearch, setView, setTab, setHistoryView, setActivityTimeRange },
    reducer: PilotsSliceReducer,
} = createSlice({
    name: pilotsSliceName,
    initialState,
    reducers: {
        setSearch: (state, action: { payload: PilotsSlice["search"] }) => {
            state.search = action.payload
        },
        setView: (state, action: { payload: PilotsSlice["view"] }) => {
            state.view = action.payload
        },
        setTab: (state, action: { payload: PilotsSlice["tab"] }) => {
            state.tab = action.payload
        },
        setHistoryView: (state, action: { payload: PilotsSlice["historyView"] }) => {
            state.historyView = action.payload
        },
        setActivityTimeRange: (state, action: { payload: PilotsSlice["activityTimeRange"] }) => {
            state.activityTimeRange = action.payload
        },
    },
})

const root = (state: RootState) => state[pilotsSliceName]

export const selectSearch = createSelector([root], (s) => s.search)
export const selectView = createSelector([root], (s) => s.view)
export const selectTab = createSelector([root], (s) => s.tab)
export const selectHistoryView = createSelector([root], (s) => s.historyView)
export const selectActivityTimeRange = createSelector([root], (s) => s.activityTimeRange)
